{
  "AcceptButton": {
    "AbortOption": "No",
    "AlternativeButtonLabel": "Save",
    "ConfirmDeleteQuestion": "Are you sure?",
    "ConfirmOption": "Yes",
    "DefaultButtonLabel": "Accept"
  },
  "AddExternalLinkModal": {
    "AddAndClose": "Add and close",
    "AddAndNew": "Add and new",
    "AddLink": "Add link",
    "Anchor": "Anchor",
    "Auto": "Auto",
    "FullUrlOrId": "Full URL eller #ID",
    "InvalidForm": "Invalid form",
    "LinkAdded": "Link added",
    "NewCommonTab": "New common tab",
    "NewTab": "New tab",
    "SameTab": "Same tab",
    "TitleOnUrl": "Title"
  },
  "AnalyticsView": {
    "Analysis": "Analysis",
    "AnalysisTable": {
      "EditorUrl": "Editor URL",
      "PageLocale": "Page language",
      "PageStatus": "Page status",
      "PageTitle": "Page title",
      "PortalUrl": "Portal URL"
    },
    "BlockTypeUsageAnalyzer": {
      "DescriptiveText": "Here you can see where different module types are used on your website. Select a module type from the dropdown menu and click 'Run analysis' to see the results.",
      "RunAnalysisButton": "Run analysis"
    },
    "WhatPagesUseWhatModules": "Which pages use which modules"
  },
  "ArticleTitleBlock": {
    "Heading": "Heading; only needs to be specified if it should differ from the page’s title (see page settings)",
    "HideInsertTitle": "Hide insert title",
    "InsertTitle": "Insert title",
    "Preamble": "Preamble",
    "SyncPageDescription": "Use page description as preamble"
  },
  "AttachmentsBlock": {
    "MaxRows": "Max rows (before show all button)",
    "SearchFieldText": "Label for list search field",
    "ShowSearchField": "Show list search field",
    "NoAttachmentsAdded": "No files added. You can add mulitple files using the button below."
  },
  "BannerBlock": {
    "AddMediaButtons": {
      "addAudio": "Audio file",
      "addIcon": "Add icon",
      "addSvg": "SVG"
    },
    "AddSlideshowImagesDescription": "NOTE: We will maximum show 5 images in the slideshow; the main image and the first 4 or random additional images from the list below.",
    "AddSlideshowImagesRandomizeLabel": "Show in random order.",
    "AddSlideshowImagesLabel": "Add more images as slideshow ({{count}})",
    "AdvancedSettings": {
      "dmSearch": {
        "Label": "Include external DigitaltMuseum search field",
        "completeUrl": {
          "HelperText": "Paste the complete URL after setting up the search in DigitaltMuseum.",
          "Label": "DigitaltMuseum search context (url encoded)",
          "Placeholder": "Complete URL from DM"
        },
        "labelButton": {
          "Label": "Text on search button",
          "Placeholder": "Search"
        },
        "labelPlaceholder": {
          "Label": "Text in search field",
          "Placeholder": "Search on DigitaltMuseum.no"
        }
      },
      "effect": {
        "HelperText": "Can not be combined with beta:slides",
        "Label": "Beta: Effect on image",
        "options": {
          "": "No effect",
          "parallax": "Parallax (Use sparingly)",
          "zoom": "Zoom-In",
          "effect-media-contain": "Show entire image always",
          "effect-media-contain-on-phone": "Show entire image on mobile portrait",
          "effect-media-contain-on-large": "Show entire image on larger screens (e.g., desktop)"
        }
      },
      "svgLogo": {
        "HelperText": "SVG logo as alternative to title",
        "Label": "SVG Logo"
      },
      "tocId": {
        "HelperText": "ID for internal link",
        "Label": "ID"
      }
    },
    "BannerBlockTextEditor": {
      "recommendationLabel": "We recommend minimal use of text here."
    },
    "BannerBlockTextLineColorSelector": {
      "label": "Text lines",
      "line-dark": "Dark semi transparent line",
      "line-light": "Light semi transparent line"
    },
    "BannerMediaBackground": {
      "Remove": "Remove image",
      "gradient": "Gradient",
      "hideVideoControls": "Hide video controls",
      "label": "Add media background",
      "localCaption": "Local caption",
      "localCaptionDescription": "Overrides global caption",
      "mediaCredits": "Media credits",
      "mediaCreditsDescription": "Media credits are shown discreetly",
      "overlay": "Overlay",
      "vignette": "Vignette",
      "usePosterImage": "Show poster image before video plays",
      "skin": "Color on vignette, gradient or overlay (if other than black)"
    },
    "BannerTitle": {
      "BannerBlockTitleAlignmentSelector": {
        "center": "Center",
        "default": "Auto",
        "left": "Left",
        "right": "Right",
        "tooltip": "Text alignment"
      },
      "BannerBlockTitleSizeSelector": {
        "default": "Default",
        "large": "Large",
        "medium": "Medium",
        "normal": "Normal",
        "small": "Small",
        "tooltip": "Text size",
        "xl": "XL",
        "xxl": "XXL"
      },
      "BannerBlockTitleTransformationSelector": {
        "capitalize": "Capitalize",
        "lowercase": "Lowercase",
        "normal": "Normal",
        "tooltip": "Transformation",
        "uppercase": "Uppercase"
      },
      "BannerBlockTitleVerticalAlignmentSelector": {
        "bottom": "Bottom",
        "default": "Auto",
        "justify": "Justify",
        "middle": "Middle",
        "tooltip": "Vertical alignment",
        "top": "Top"
      },
      "BannerBlockTitleWeightSelector": {
        "black": "Black",
        "bold": "Bold",
        "default": "Auto",
        "extrabold": "Extrabold",
        "light": "Light",
        "medium": "Medium",
        "normal": "Normal",
        "regular": "Regular",
        "semibold": "Semibold",
        "thin": "Thin",
        "tooltip": "Font weight"
      },
      "HideTitleLabel": "Hide title",
      "RunningHeadLabel": "Running head",
      "SetTitleAsH1": "Use as the page’s main heading (H1)",
      "TitleLabel": "Title"
    },
    "LinksLabel": "Links/Buttons",
    "CloseSlideshowImagesButton": "Close slideshow",
    "MoreSettingsLabel": "More settings",
    "NextButtonLabel": "Show arrow down to next banner or section (e.g. from top banner)",
    "VideoBannerExplanation": "Video in banner is only used as a background effect, and is played automatically without sound, full screen, in loop and without controllers (pause, full screen, etc.). If you need regular video functions, use the Video module in Content section.",
    "legacySettings": "Use 'Box' and 'Textlines' view methods instead of these settings",
    "transparent": "Transparent banner (useful for intro sections where there are background images in the background)",
    "useModuleContentBackgound": "Semitransparent box behind text",
    "useTextbackgound": "Semitransparent text lines"
  },
  "ButtonCollection": {
    "ShowLess": "Show less",
    "ShowMore": "Show more"
  },
  "BylineBlock": {
    "Author": "Author",
    "ChoosePerson": "Choose person",
    "Description": "Description",
    "Employee": "Employee",
    "FindImage": "Find image",
    "Manual": "Manual",
    "Person": "Person-card",
    "PersonCardsNotSupported": "Personcards not longer supported. Pick an employee or use manual mode",
    "UploadImage": "Upload image",
    "WrittenBy": "Written by"
  },
  "CaptionInput": {
    "CaptionLabel": "Caption",
    "HideCaption": "Hide captions"
  },
  "CardEditor": {
    "BothInternalAndExternal": "Both internal and external links are set. The internal link will be used.",
    "Category": "Select card category",
    "Description": "Description (keep it short!)",
    "EditCard": "Edit card",
    "FindImage": "Find image",
    "Footer": "Footertext",
    "FooterLocation": "Place (text)",
    "ImageFieldTitle": "Select image",
    "InternalCard": "Internal link",
    "NoCategory": "No category",
    "Page": "Pagelink",
    "RemoveImage": "Remove image",
    "RemovePage": "Remove page",
    "SelectPage": "Select page",
    "SelectSkin": "Select color",
    "SwapImage": "Change image",
    "Title": "Title",
    "Url": "External link",
    "UrlDescription": "Full URL, e.g. https://museum.no",
    "UrlExternal": "Link (external)",
    "callToActionButtonText": "Read more text"
  },
  "CardModuleBlock": {
    "Auto": "Auto",
    "AutoOldSettings": "Settings from Museum24 1.0",
    "CardSizeSelector": {
      "collapsed": "Collapsed",
      "label": "Select size for all cards",
      "large": "Large",
      "medium": "Medium",
      "small": "Small",
      "undefined": "Not set"
    },
    "MediaSizeSelector": {
      "label": "Media-ratio for all cards",
      "16-9": "16:9",
      "4-3": "4:3",
      "3-2": "3:2",
      "1-1": "1:1",
      "2-3": "2:3",
      "3-4": "3:4",
      "free": "Free",
      "undefined": "Not set (auto)"
    },
    "GridMobileBehaviourLabel": "Grid mobile behaviour",
    "ListMobileBehaviourLabel": "List mobile behaviour",
    "GridSizeLabel": "Grid size",
    "GroupByLabel": "Grouping of cards (see result in end portal)",
    "Manual": "Manuell",
    "category": "Category",
    "events": "Date(s)",
    "footerLocation": "Location (text)",
    "footerText": "Footertext",
    "includeGlobalListSearch": "Make list search global",
    "includeListSearch": "Include list search field",
    "listSearchText": "Text in search field",
    "location": "Location",
    "metadataformat": "Metadata format",
    "noMeta": "Hide metadata/footer",
    "place": "Museum",
    "ChangeCard": "Change card (global)",
    "ChangesSaved": "Changes are saved. You need to save the page again to see the changes in preview. In the end portal they will be in place already."
  },
  "CardModuleBlockCardSearch": {
    "FilterCategories": "Categories",
    "FilterTags": "Key words",
    "FooterLink": "Button at the bottom (link to more)",
    "Metadata": "Metadata on the cards",
    "Order": "Sort order",
    "OrderBy": "Sort by",
    "OrderBySelector": {
      "date": "Published date",
      "event": "Calendar data",
      "false": "Manual",
      "title": "Alphabetical: Title"
    },
    "OrderSelector": {
      "asc": "Ascending",
      "desc": "Descending"
    },
    "Rows": "Max results",
    "Title": "Card search"
  },
  "CardModuleBlockItem": {
    "GridSizeSelector": {
      "collapsed": "Collapsed",
      "default": "Not set",
      "label": "Select size",
      "large": "Large",
      "medium": "Medium",
      "small": "Small"
    }
  },
  "CardModuleViewTypeSelector": {
    "CardModuleViewTypeVariant": {
      "articles": "Article list",
      "auto": "Auto",
      "grid": "Grid",
      "horizontal": "Horizontal scroll",
      "list": "List",
      "card": "Card",
      "col-1": "One column on mobile (portrait)"
    }
  },
  "CardsView": {
    "BlockType": {
      "article__card": "Cards",
      "article__person": "Persons (Deprecated)"
    },
    "BlockTypeLabel": "Type:",
    "CategoriesInfo": "*Card categories are the categories that were in the old Museum24. A separate setup has now been created for ARRANGEMENTS.",
    "CategoriesInfoLinkText": "Read more here.",
    "CategoriesLabel": "Card categories*:",
    "CreateCard": "Create new card",
    "Title": "Cards",
    "PersonsInfo": "Use employee-gallery and employee-modules instead",
    "CardFilter": {
      "unpublished": "Not published",
      "internal_card": "Internal cards",
      "all": "All",
      "external_card": "External cards"
    }
  },
  "CommonBlockContent": {
    "Alignment": {
      "Tooltip": "Text alignment",
      "auto": "Auto",
      "center": "Right",
      "left": "Left",
      "module": "Module (left)"
    },
    "BlockSettings": "Title and description",
    "FormLabels": {
      "AnchorID": "Anchor",
      "Body": "Description"
    }
  },
  "CommonSectionContent": {
    "FormLabels": {
      "AnchorID": "Anchor",
      "Arrows": "Show arrows",
      "BackgroundMedia": "Media background",
      "BackgroundPosition": "Background position",
      "CarouselSettings": "Settings for carousel view",
      "CarouselAutoplay": "Autoplay",
      "CarouselAutoplaySpeed": "Autoplay speed (milliseconds)",
      "CarouselTransition": "Transition effect",
      "CssClass": "CSS Class",
      "Filter1": "Filter 1",
      "Filter2": "Filter 2",
      "MediaCredits": "Captions/Photographer/License",
      "MobileBehavior": "Mobile behavior",
      "MobileBehaviorDescription": "Normally, two small modules are displayed in width on mobile, other sizes are displayed in one column.",
      "Modifier": "Grid size",
      "ModifierDescription": "Normally, 4 small modules are displayed in width on larger screens. Here you can change this.",
      "PaddingBottom": "Space below",
      "PaddingTop": "Space above",
      "Spacing": "Space between banners",
      "TextColor": "Text color",
      "Title": "Title",
      "ToggleIntrosection": "Enable Scrollytell section",
      "ToggleVisibleTitle": "Display title",
      "ToggleCenterTitle": "Center title",
      "RemoveLeftPadding": "Remove padding to the left on banners (for left-aligned text)"
    },
    "SectionSettings": "Section settings",
    "arrows": {
      "allways": "Always",
      "first": "Only on first module",
      "none": "Never"
    },
    "backgroundPosition": {
      "center": "Center",
      "contain": "Contain",
      "top": "Top"
    },
    "filter": {
      "animation-zoom": "Zoom animation",
      "filter-blur": "Blur",
      "filter-blur-2": "Blur 1",
      "filter-blur-3": "Blur 2",
      "filter-blur-5": "Blur 3",
      "filter-blur-10": "Blur 4",
      "filter-blur-15": "Blur 5",
      "filter-blur-20": "Blur 6",
      "filter-blur-30": "Blur 7",
      "filter-blur-50": "Blur 8",
      "filter-brightness": "Brightness",
      "filter-brightness-04": "Brightness 1",
      "filter-brightness-05": "Brightness 2",
      "filter-brightness-06": "Brightness 3",
      "filter-brightness-07": "Brightness 4",
      "filter-brightness-08": "Brightness 5",
      "filter-contrast": "Contrast",
      "filter-contrast-05": "Contrast 1",
      "filter-contrast-08": "Contrast 2",
      "filter-grayscale": "Grayscale",
      "filter-grayscale-03": "Grayscale 1",
      "filter-grayscale-05": "Grayscale 2",
      "filter-grayscale-08": "Grayscale 3",
      "filter-sepia": "Sepia",
      "filter-sepia-05": "Sepia 1",
      "filter-sepia-08": "Sepia 2"
    },
    "mobileBehavior": {
      "auto": "Auto (2 columns)",
      "col-1": "One column on mobile (portrait)"
    },
    "modifier": {
      "auto": "Auto (4 columns)",
      "grid33": "3 columns (one column on mobile)"
    },
    "padding": {
      "0": "0",
      "1": "1",
      "2": "2",
      "3": "3",
      "4": "4",
      "5": "5",
      "6": "6",
      "10": "10",
      "auto": "Auto"
    },
    "spacing": {
      "0": "None",
      "1": "Space",
      "2": "Space",
      "auto": "Auto",
      "line": "Line"
    },
    "textColor": {
      "dark": "Dark",
      "light": "Light"
    },
    "transition": {
      "fade": "Fade",
      "slide": "Slide"
    }
  },
  "ContentView": {
    "backToEventsButtonLabel": "Back to the events",
    "backToPageTreeButtonLabel": "Back to the page tree",
    "eventsTitle": "Events",
    "importedPagesButtonLabel": "Imported pages",
    "importedPagesDeleteStopped": "{{done}} of {{total}} pages were deleted. The rest are still in the list.",
    "importedPagesDeleted": "{{count}} page(s) deleted",
    "importedPagesPublished": "{{count}} page(s) published and placed in the page tree",
    "openImportedPagesHere": "Open here",
    "openImportedPagesInNewWindow": "Open in a new window",
    "pagesTitle": "Pages"
  },
  "CreatePageModal": {
    "CreateEventFailed": "Create event failed",
    "CreateEventSuccessful": "Event created successfully",
    "CreateNewEvent": "Create new event",
    "CreateNewPage": "Create new page",
    "CreateNewTemplate": "Create new template",
    "CreatePageFailed": "Create page failed",
    "CreatePageSuccessful": "Page created successfully",
    "CreateTemplateFailed": "Create template failed",
    "CreateTemplateSuccessful": "Template created successfully",
    "EventTitle": "Event title",
    "InvalidForm": "Invalid form",
    "NewEvent": "New event",
    "NewPage": "New page",
    "NewTemplate": "New template",
    "NoSiteId": "No site ID",
    "PageTitle": "Page title",
    "Path": "Path",
    "PathAlreadyExists": "Path already exists",
    "PathReservedForLanguage": "This url-path is reserved for language versions of the site.",
    "PathExample": "(E.g. museum.no/en for English etc.)",
    "Under": "Under",
    "UnsavedChangesWarning": "You have unsaved changes! The changes will be lost if you continue.",
    "save_and_close": "Save and close",
    "save_and_create_new": "Save and new",
    "save_and_edit": "Save and edit"
  },
  "CurrentPageInfo": {
    "ShowingXToYOutOfZItems_one": "Showing {{from, number}} - {{to, number}} out of {{count, number}} item",
    "ShowingXToYOutOfZItems_other": "Showing {{from, number}} - {{to, number}} out of {{count, number}} items"
  },
  "DMBlock": {
    "AddFilteringSortingForUsers": "Add filtering/sorting for users",
    "AltDescriptionLabel": "Alternative description",
    "AltTitleLabel": "Alternative title",
    "AlternativeFields": "Fill in alternative text",
    "DigitalResources": "Digital resources",
    "DMItemsLabel": "Pick items from DM",
    "DMMuseumLabel": "Pick a museum from DM",
    "DmLinkLabel": "Button below list with custom link to DigitaltMuseum",
    "DmLink": "Complete URL for Go to DigitaltMuseum (button)",
    "DmLinkText": "Text on DigitaltMuseum button",
    "EnableSearch": "Show search box to search in Digitalt Museum",
    "EndUserFilteringSorting": {
      "gradeFilter": "Grade",
      "subjectFilter": "Subject",
      "ownerFilter": "Museum",
      "resourceTypeFilter": "Resource type",
      "sortBySelector": "Sort type",
      "orderSelector": "Sort order",
      "queryFilter": "Free text search"
    },
    "HasPictures": "Has images only",
    "LicenseTypesLabel": "Filter by license types",
    "MaxItemsLabel": "Number of items to show",
    "NoImages": "The item has no images",
    "SearchConfig": "Rules for the search",
    "ObjectTypesLabel": "Filter by DM object types",
    "OrderBySelector": {
      "Label": "Sorting",
      "options": {
        "score": "Relevance",
        "relevance": "Relevance",
        "last_updated": "Last updated",
        "published_at": "Publication date"
      }
    },
    "OrderSelector": {
      "Label": "Sort order",
      "options": {
        "asc": "A-Å",
        "desc": "Å-A"
      }
    },
    "OwnerCodesLabel": "List of owner codes",
    "OwnerCodeSelectOne": "Select at least one owner code",
    "PaginateMaxItemsLabel": "Button for loading max items",
    "PhysicalResources": "Physical resources (visit to the museum)",
    "PreviewFilterInfo": "Filter for end user is on. See result in portal",
    "QueryLabel": "Free text search of the list",
    "RemoveObject": "Remove selected object",
    "School": {
      "Grades": {
        "SelectGrade": "Select grade",
        "Options": {
          "kindergarten": "Kindergarten",
          "grade_two": "1st to 2nd grade",
          "grade_four": "3rd to 4th grade",
          "grade_seven": "5th to 7th grade",
          "grade_ten": "8th to 10th grade",
          "vg_one": "Vg1",
          "vg_two": "Vg2",
          "vg_three": "Vg3"
        }
      },
      "SelectAtLeastOneOwner": "Velg minst ett museum",
      "Subject": {
        "SelectSubject": "Select subject",
        "Options": {
          "SocialStudies": "Social Studies",
          "Science": "Science",
          "Norwegian": "Norwegian",
          "DramaAndRhythmics": "Drama and Rhythmics",
          "ReligionEthicsLifeStance": "Religion, Ethics, and Life Stance Studies",
          "ArtsAndCrafts": "Arts and Crafts",
          "FoodAndHealth": "Food and Health",
          "Music": "Music"
        }
      }
    },
    "SelectMainPicture": "Select which picture to display",
    "Show": "Show",
    "ShowSchoolTypes": "School types (all shown as standard)",
    "SubjectsLabel": "Comma separated list of subjects",
    "UseOwnerCodes": "Filter by DM owners",
    "VisitTheMuseums": "Visit the museums",
    "VRItemsLabel": "Pick virtual experiences from DM",
    "WideDisplayLabel": "Use a wider style"
  },
  "DMFilterSearch": {
    "CustomKeywords": "Custom keywords (comma-separated)",
    "CustomKeywordsTitleLabel": "Keywords",
    "CustomKeywordsDropDownMenuTitleLabel": "Dropdown menu title",
    "ExhibitionIdTitleLabel": "Exhibition UUID",
    "FolderIdTitleLabel": "Folder UUID",
    "FreeTextSearch": "Free text search",
    "FreeTextSearchTitleLabel": "Free text search",
    "FreeTextSearchDropDownMenuTitleLabel": "Dropdown menu title",
    "IncludeFreeTextSearchLabel": "Include free text search (the search is performed within the parameters selected above)",
    "InputLabelProducers": "Producers (comma-separated)",
    "InputLabelMaterials": "Material (comma-separated)",
    "InputLabelSubjectKeywords": "Subject keywords (comma-separated)",
    "InputLabelTechnique": "Technique (comma-separated)",
    "ItemsRestriction": "Absolute restriction",
    "KulturNavTitleLabel": "KulturNav entry",
    "LicenseTypesLabel": "DM license types",
    "LicenseTypesDropDownMenuTitleLabel": "Dropdown menu title",
    "LicenseTypesTitleLabel": "Licenses",
    "LimitTitleLabel": "Number of items to display",
    "MaterialsDropDownMenuTitleLabel": "Dropdown menu title",
    "MaterialsTitleLabel": "Materials",
    "MuseumsCollectionsTitleLabel": "Museums/collections",
    "ObjectTypesTitleLabel": "Object types",
    "ObjectTypesDropDownMenuTitleLabel": "Dropdown menu title",
    "ObjectTypesSelectInputLabel": "DM object types",
    "OwnerCodesDropDownMenuTitleLabel": "Dropdown menu title",
    "OwnerCodesLabel": "List of owner codes",
    "NoAccessMessage": "This component is set up by KulturIT employees. Please contact if you want to change it.",
    "Producers": "Producers",
    "ProducersDropDownMenuTitleLabel": "Dropdown menu title",
    "ProducersTitleLabel": "Producers",
    "ShowInSameTab": "Show in same tab (when click on DM item)",
    "ShowOnlyObjectsWithImage": "Show only objects with image",
    "SubjectKeywordsFilter": "Subject keyword filtering",
    "SubjectKeywordsDropDownMenuTitleLabel": "Dropdown menu title",
    "SubjectKeywordsTitleLabel": "Subject keywords",
    "TechniqueDropDownMenuTitleLabel": "Dropdown menu title",
    "TechniqueTitleLabel": "Technique",
    "Time": "Time",
    "TimeSliderTitle": "Slider title",
    "TimeTitleLabel": "Time",
    "TimeYearFrom": "Year from",
    "TimeYearTo": "Year to",
    "UserFiltrationOnWebsite": "User filtering on website"
  },
  "DMFinderHeader": {
    "FilterLabel": "Filter the DM search",
    "HasLocation": "..coordinates",
    "HasPictures": "Has pictures",
    "HasVideo": "..video",
    "HasAudio": "..audio",
    "ObjectType": "Object type",
    "OnlyOurOwnerCode": "Only our owner code ({{ownerCode}})",
    "OnlyOurOwnerCodes": "..owner codes",
    "Owner": "Owner"
  },
  "DMHeader": {
    "LicenseLabel": "License:",
    "OwnerLabel": "Owner:"
  },
  "DMImagePicker": {
    "Cancel": "Cancel",
    "Confirm_one": "Use {{count}} image",
    "Confirm_other": "Use {{count}} images",
    "ImageLabel": "Image {{number}}",
    "InfoTextMultiple": "The object has several images. Pick one or more.",
    "InfoTextSingle": "The object has several images. Pick one.",
    "NoImages": "No images found on the object."
  },
  "DMViewTypeSelector": {
    "grid": "Grid",
    "list": "List",
    "simple": "Links with arrow (no image)",
    "map": "Map"
  },
  "DashboardView": {
    "BottomBanner": {
      "GetStarted": "Get started with M24",
      "Heading": "How to use Museum24",
      "KeywordIndex": "Keyword index",
      "Text": "Functions, buildingblocks and examples",
      "TipsAndInspiration": "Tips and inspiration",
      "UserManual": "Go to website"
    },
    "ContentWidget": {
      "EventsTitle": "Events",
      "LastEdited": "Last edited",
      "PagesTitle": "Content"
    },
    "CountResLabel": {
      "archived": "Archived",
      "audio": "Audio",
      "document": "Documents",
      "draft": "Draft",
      "image": "Images",
      "in_use": "In use",
      "published": "Published",
      "total": "Total",
      "video": "Video"
    },
    "EventsLabel": "Events",
    "FormsLabel": "Forms",
    "FormsWidget": {
      "Title": "Forms"
    },
    "MediaLabel": "Media",
    "MediaWidget": {
      "DAMSIntegrationEnabled": "DAMS integration enabled",
      "Title": "Media"
    },
    "MessagesWidget": {
      "Title": "Messages from museum24"
    },
    "PagesLabel": "Pages",
    "SettingsShortcutWidget": {
      "ChangeFooter": "Change footer",
      "ChangeMenu": "Change top menu"
    },
    "SharingWidget": {
      "AccessGiven": "Sharing with other sites",
      "AccessGranted": "Access granted to other sites",
      "NewRequests": "You have new requests",
      "NoNewRequests": "No new requests",
      "NoSharing": "No sharing",
      "Title": "Access/sharing"
    },
    "ReindexPagesWidget": {
      "Title": "Search index",
      "IncludeAllSites": "Include all sites",
      "Reindex": "Reindex",
      "Reindexing": "Reindexing...",
      "ReindexSuccess": "Reindexing successful",
      "ReindexFailed": "Reindexing failed: {{error}}"
    },
    "WelcomeBannerWidget": {
      "DescriptionLabel": "Site description",
      "ImageLabel": "Site main image",
      "NoDescription": "– No description (add under front page meta settings)",
      "NoFavicon": "– No favicon (add favicon (and touchicon) under site settings)",
      "NoImage": "– No main image (add under front page meta settings)",
      "NoDescriptionOrImage": "Description and main image are added under the front page meta settings."
    }
  },
  "DatelineBlock": {
    "Dateline": "Dateline",
    "DatelineDescription": "Shows the publishing date, and the time if you like. It can also show when the content was last modified.",
    "LabelLastModifiedText": "Text before last modified",
    "LabelPublishedDate": "Publication date",
    "LabelShowLastModified": "Show last modified date",
    "LabelShowTime": "Show time (for both dates)",
    "LabelText": "Text before publishing date",
    "LastModifiedDefaultText": "Last modified",
    "Metadata": "Metadata",
    "MetadataDescription": "Metadata is no longer used in version 2.0. To add events, use the event module.",
    "ShowLastModifiedHelp": "Only shown when it is a different date than the publishing date, or a different time when the time is shown."
  },
  "DeleteButton": {
    "AbortOption": "No",
    "AlternativeButtonLabel": "Remove",
    "ConfirmDeleteQuestion": "Are you sure?",
    "ConfirmOption": "Yes",
    "DefaultButtonLabel": "Delete"
  },
  "EditSelectedMedia": {
    "ConfirmUpdateSelection": "Are you sure you want to update all selected items?"
  },
  "EditorBreadcrumbItem": {
    "ChildrenLabel": "Sub pages",
    "CreateChildPage": "Create sub page",
    "EditLinkLabel": "Edit {{title}}",
    "NoChildren": "No sub pages"
  },
  "EditorHeader": {
    "CreateEvent": "Create new event",
    "CreatePage": {
      "ActionMenuLabel": "Create new page",
      "Child": "Under this page",
      "Sibling": "On the same level"
    },
    "GoBack": "Go back",
    "ImportedPlaceHint": "Imported page. \"Save and publish\" publishes it and puts it at the root of the page tree.",
    "LastUpdatedAt": "Last updated {{at}}",
    "PublishedAt": "Published at {{timestamp}}",
    "TemplateTooltip": "This is a template, and is not available in the portal",
    "pageSettings": "Page settings",
    "pageTemplateSettings": "Template settings"
  },
  "EditorPreviewContainer": {
    "FlipDeviceOrientation": "Flip orientation",
    "PreviewType": {
      "auto": "Auto",
      "desktop": "Desktop",
      "desktop_4k": "Desktop (4K)",
      "developer": "Developer",
      "fill": "Fill",
      "mobile": "Mobile",
      "tablet": "Tablet"
    },
    "ShowInPortal": "View currently published version in portal"
  },
  "EditorSectionActionButton": {
    "Tooltip": "Actions"
  },
  "EkulturCallbackHandler": {
    "errors": {
      "missingCodeOrState": "Missing information needed to complete login",
      "swapForTokenFailed": "An error occurred. Unable to log in"
    },
    "loggingIn": "Logging in"
  },
  "EkulturLoginController": {
    "LoadingUser": "Checking user...",
    "LoggedInAsUser": "You are logged in as: {{user}}",
    "NoAccess": "You do not have access to this app. Please contact your eKultur administrator to get access."
  },
  "EkulturLogoutHandler": {
    "logOutNow": "Log out now",
    "loggingOut": "Logging out...",
    "loggingOutInXSec_one": "You are being logged out in 1 second...",
    "loggingOutInXSec_other": "You are being logged out in {{count}} seconds...",
    "logoutFailed": "An error occurred during logout"
  },
  "EmployeeEditor": {
    "AddExternal": "Add external link",
    "AddPage": "Add page link",
    "ChangePage": "Change page",
    "ContactFieldsTitle": "Contact information",
    "Department": "Department",
    "Description": "Description / free text",
    "Email": "Email address",
    "FindImage": "Select image",
    "Firstname": "First name",
    "ImageFieldTitle": "Image and focus point",
    "InvalidUrl": "Invalid URL format",
    "Lastname": "Surname",
    "LinkName": "Link name",
    "LinksFieldTitle": "Links",
    "Page": "Page",
    "PageLinkTitle": "Page link",
    "PageLinkAbout": "This link will be displayed on the employee card and lead to a page on the website. The page must be created first and can contain more information about the employee, such as a research profile, projects, or similar. The link will also be used in the Byline module.",
    "PageLinkExternalAbout": "This/these link(s) will be displayed on the employee card and lead to the specified URL. The top link will also be used in the Byline module if no internal page link is specified above.",
    "Phone": "Phone number",
    "Position": "Position",
    "RemoveImage": "Remove image",
    "RemoveLink": "Remove link",
    "RemovePage": "Remove page",
    "RequiredFieldsMissing": "Required fields missing: {{fields}}",
    "SaveFailed": "Something went wrong while saving: {{error}}",
    "SaveSuccess": "Employee saved",
    "SelectPage": "Select page",
    "SwapImage": "Change image",
    "TextFieldsTitle": "Personal information",
    "UrlExternal": "External url"
  },
  "EmployeesBlock": {
    "EnableSearch": "Show search box",
    "SearchTypeLabel": "Type of search box",
    "SearchTypeOptions": {
      "local": "Local: Filter employees in this module",
      "page": "Page: Filter employees in all modules on this page",
      "site": "Searchpage: Goes to regular employee search for this site"
    },
    "EnableEmployeeSiteSearch": "Show search box to search employees via site search",
    "SelectInfoToShow": "Select which fields to show",
    "ShowDepartment": "Department",
    "ShowDescription": "Description",
    "ShowEmail": "Email",
    "ShowLinks": "Links",
    "ShowPhone": "Phone number",
    "ShowPosition": "Position",
    "ShowSite": "Museum"
  },
  "EmployeesView": {
    "AddEmployee": "Add employee",
    "HeaderCount": "Showing {{count}} of {{total}} employees",
    "Title": "Employees"
  },
  "EmployeesViewTypeSelector": {
    "grid": "Grid",
    "list": "List"
  },
  "EventData": {
    "AddTime": "Add new time",
    "CategoryTitle": "Category: Event",
    "Title": "Event title ( = page title)",
    "Description": "Event description",
    "EndTime": "End time",
    "FreeText": "Free text",
    "InvalidUrl": "Invalid URL (https://...)",
    "Location": "Event location",
    "LocationText": "Unregistered placeinfo",
    "LocationTooltip": "These locations are added in your site settings",
    "ShowAsOneCardPerDateRow": "Show as one card per date row",
    "SkinLabel": "Select color for listing",
    "StartTime": "Start time",
    "SubCategoryInfo": "You don't have to select any sub-categories if there are no needs to specify further or filter on event type.",
    "SubCategoryLabel": "Select sub-categories for event",
    "TicketText": "Ticket button text",
    "TicketUrl": "URL link to tickets",
    "TimeInfoLabel": "Additional time information",
    "UseEndDateLabel": "Include end time",
    "UseRangeLabel": "Define a time period",
    "UseTimeLabel": "Include time of day",
    "Weekdays": "Weekdays",
    "EnableStructuredMarkup": "Mark as 'Google event'"
  },
  "EventsBlock": {
    "CategoriesFilteringLabel": "Event categories",
    "DateFilteringLabel": "Dates",
    "DisableExpandedDates": "Never expand cards",
    "DisplayOptions": {
      "Category": "Event categories",
      "Description": "Description",
      "Location": "Location",
      "Museum": "Museum (site)"
    },
    "EventsLabel": "Arrangementer",
    "FinderButton": "Select events",
    "LocationFilteringLabel": "Places",
    "MaxItemsLabel": "Max items",
    "MuseumFilteringLabel": "Museums",
    "NoEventsSelected": "No events are added to this block yet",
    "PreviewFilterInfo": "Event filter is on. See result in portal",
    "Rules": "Rules for search",
    "ShowAllLinkPageButtonLabel": "Select page",
    "ShowAllLinkPageTitle": "Link to \"Show more\"",
    "ShowAllLinkType": {
      "button": "Button",
      "text": "Text link"
    },
    "ShowAllLinkTypeLabel": "Show link as",
    "ShowForPeriodLabel": "Show for period",
    "ShowForPeriodType": {
      "1m": "1 month",
      "3m": "3 month",
      "6m": "6 month",
      "12m": "12 month",
      "previous": "Previous",
      "specify": "Specify period",
      "today": "Todays"
    },
    "TargetGroupsFilteringLabel": "Target groups",
    "TodayFilteringLabel": "Today",
    "UseFilteringLabel": "Filter by",
    "UseLocationFiltering": "Locations",
    "UseMuseumFiltering": "Museums",
    "UserFilteringLabel": "Add filtering/sorting for end user of the listing",
    "EnableSearchLabel": "Show search box",
    "OrderFilteringLabel": "Sort order"
  },
  "FavouriteButton": {
    "MarkAsFavourite": "Mark as favourite",
    "UnmarkAsFavourite": "Unmark as favourite"
  },
  "FilterMenu": {
    "FilterMenuTooltip": "Filter pages",
    "sections": {
      "MainCategories": "Main categories",
      "Statuses": "Statuses",
      "SubCategories": "Sub categories"
    }
  },
  "Finder": {
    "CardTitle": "Cards",
    "EventsTitle": "Events",
    "Filter": {
      "CardType": "Card types",
      "IncludeMediaTypes": "Media types",
      "OnlyOwnerContent": "Only added by Owner: {{ownerName}}",
      "OnlyUserContent": "Only added by me",
      "ShowContentFrom": "Show content from..."
    },
    "FinderSource": {
      "digitalt_museum": "Digitalt Museum",
      "e_kultur": "eKultur",
      "favourites": "Favourites",
      "museum_24": "Museum 24"
    },
    "MediaTitle": "Media gallery",
    "MediaTitleDams": "DAMS gallery",
    "PageTitle": "Pages",
    "Search": "Search for content...",
    "SelectMuseum": "Select museum",
    "SelectDamsGallery": "Select DAMS gallery",
    "TemplatesTitle": "Templates",
    "UseSelected_interval": "(0)[No elements selected];",
    "UseSelected_one": "Use selected",
    "UseSelected_other": "Use selected ({{count}})"
  },
  "FinderButton": {
    "card": "Add a card",
    "dams": "Choose file from DAMS",
    "digitaltMuseum": "Choose file from DigitaltMuseum",
    "employee": "Add employee(s)",
    "form": "Add a form",
    "icon": "Add an icon",
    "kp": "Add objects from KulturPunkt",
    "kp_owner": "Add a Kulturio-museum",
    "m24": "Choose file or upload from media gallery",
    "m24_images_video": "Choose images or videos from the media gallery",
    "m24_images": "Choose images from the media gallery",
    "owner": "Add a museum"
  },
  "FolderView": {
    "ConfirmDeleteFolderDialogHtml": "<p>Are you sure you want to delete the folder <strong>{{folderName}}</strong>?</p><p>All subfolders will be deleted, and all pages will be moved out of folders.</p>",
    "DeleteActionButton": "Delete",
    "MoveActionButton": "Move to...",
    "MoveDialogTitle": "Move to folder",
    "cancel": "Cancel",
    "confirmMoveButton": "Move",
    "createNewFolder": "Create folder",
    "createdAtDate": "Created at {{date}}",
    "editName": "Edit name",
    "folderItemCount": "{{ count }} events",
    "newFolderDefaultName": "New folder",
    "rootFolderName": "Events",
    "newFolderNameLabel": "Folder name",
    "createAndClose": "Add",
    "createAndNew": "Add and new",
    "closeDialog": "Cancel"
  },
  "FormEditor": {
    "AddBlockType": "+ {{blockType}}",
    "AddSection": "+ Section/Step",
    "Address": {
      "AddressLabel": "Address label",
      "CountryCodeLabel": "Country code label",
      "PostalCodeLabel": "Postal code label",
      "PostalPlaceLabel": "Postal place label",
      "StateLabel": "State label"
    },
    "AttachmentsSizeLimit": "Limit file size",
    "BlockType": {
      "button": "Button",
      "checkbox": "Yes/No",
      "content": "Content",
      "input": "Input",
      "options": "Options",
      "user": "User/Address"
    },
    "InternalLabel": "Internal label",
    "ButtonLabel": "Button text",
    "EmailReceiver": "Email receiver",
    "FieldSettings": "Settings for this field",
    "FormInvalidLabel": "Text for invalid form",
    "InUseByPages": "In use by pages",
    "InputLabel": "Input label",
    "NewForm": "New form",
    "Preview": {
      "DefaultFileButtonLabel": "Find file",
      "DefaultFileLabel": "File upload",
      "button": {
        "default": "Submit",
        "next": "Next",
        "prev": "Previous",
        "reset": "Reset"
      }
    },
    "SectionInputs": "Input fields",
    "SectionReceipt": "Receipt",
    "SendEmailOnSubmissions": "Send email on submissions",
    "button": {
      "defaultBlockLabel": "Submit",
      "nextBlockLabel": "Next",
      "prevBlockLabel": "Previous",
      "prev_nextBlockLabel": "Previous/Next",
      "resetBlockLabel": "Reset"
    },
    "input": {
      "FirstNameLabel": "First name label",
      "LastNameLabel": "Last name label",
      "ShowImagePreview": "Show preview",
      "addressBlockLabel": "Address",
      "dateBlockLabel": "Date",
      "emailBlockLabel": "Email",
      "fileBlockLabel": "File upload",
      "nameBlockLabel": "Name",
      "textBlockLabel": "Text (single line)",
      "textareaBlockLabel": "Text (multiline)"
    },
    "options": {
      "AddAlternative": "Add option",
      "Horizontal": "Horizontal flow",
      "OptionN": "Option {{n}}",
      "PreSelected": "Pre-selected",
      "checkboxBlockLabel": "Multiple choices",
      "radioBlockLabel": "One choice"
    },
    "user": {
      "Address2Enabled": "Include address line 2",
      "CompleteAddressEnabled": "Include complete address (for additional info)",
      "ConfirmEmail": "User must confirm email",
      "CountryCodeEnabled": "Include country code",
      "Description": "Fields \"first name\", \"last name\" and \"email\" are always required",
      "EmailConfirmLabel": "Email confirmation label",
      "EmailLabel": "Email label",
      "FirstnameLabel": "Firstname label",
      "LastnameLabel": "Lastname label",
      "PhoneLabel": "Phone label",
      "StateEnabled": "Include state",
      "completeBlockLabel": "Complete",
      "minimumBlockLabel": "Minimum",
      "simpleBlockLabel": "Simple"
    }
  },
  "FormView": {
    "BackToOverview": "< Back to form overview",
    "CreateNewForm": "Create new form",
    "DeleteAll": "Delete all",
    "DeleteData": "Delete data",
    "DeleteIndividual": "Delete individual",
    "EditForm": "Edit form",
    "ExportData": "Export data",
    "FormData": "Form data",
    "FormDeletedFailed": "Something went wrong while deleting the form: {{error}}",
    "FormDeletedSuccess": "Form deleted",
    "NoItems": "No forms found",
    "NumberOfPagesInUse": "No. of pages in use: {{count}}",
    "OlderThanX": "Older than {{days}} days",
    "ShowAnswers": "Show answers ({{count}})",
    "Title": "Forms"
  },
  "GoogleMapsAutoComplete": {
    "AddLocationLabel": "Search for a location",
    "NoOptionsText": "No matches"
  },
  "GridViewDMVariant": {
    "License": "License",
    "Owner": "Owner",
    "Pictures": "Pictures"
  },
  "ImageWithFocusPointSelector": {
    "SelectFocusPoint": "Select focus point for {{imageName}}",
    "SelectFocusPointDescription": "Select focus point"
  },
  "KPBlock": {
    "AdditionalPointsTooltip": "These KulturPunkt articles are shown in addition to potential sub-articles or selections from a presentation above",
    "BigViewLabel": "Big view",
    "displayDescription": "Show description",
    "DisplayOptionsModuleLabel": "Display options for this module",
    "DisplayOptionsItemLabel": "Display options for the items",
    "IntegratedView": "Integrated fullview",
    "IntegratedViewLabel": "Open content in integrated view instead of at KulturPunkt.org",
    "JustBanner": "Just show banner",
    "KPArticlesLabel": "Pick KulturPunkt articles",
    "KPOwnersLabel": "Pick museums from Kulturio",
    "KPPresentationLabel": "Pick a KulturPunkt presentation",
    "KPPresentationsLabel": "Pick KulturPunkt presentations",
    "ListArticles": "Show KulturPunkt articles",
    "ListArticlesLabel": "List sub-articles",
    "ListPresLabel": "List sub-presentations",
    "ListPresentations": "Show presentations",
    "MapSettings": "Map settings",
    "NoBackground": "No background color (transparent)",
    "PickSelectionLabel": "Pick a selection",
    "PickSubArticlesLabel": "Pick sub-articles",
    "PresChildrenLabel": "Pick KulturPunkt articles from this presentation",
    "whiteBackground": "White background",
    "disableEkulturMapPin": "Use standard map pin"
  },
  "KPFinderHeader": {
    "FilterByOwner": "Only show objects belonging to your own Kulturio owner",
    "KPOwnerHeader": "Museums",
    "KPSchemaType": {
      "2": "KulturPunkt articles",
      "12": "KulturPunkt presentations",
      "13": "Kulturio Kiosk views",
      "14": "Kulturio Kiosk devices"
    }
  },
  "LicenseSelector": {
    "SelectLicense": "License"
  },
  "LinkListBlock": {
    "AdvancedSettings": {
      "GroupBy": {
        "Label": "Grouping of links",
        "alpha": "Alphabetical",
        "false": "No"
      },
      "OrderBy": {
        "Label": "Automatic sorting of links",
        "_date": "Date (published)",
        "_title": "Alphabetical (title)",
        "false": "Manual"
      },
      "Title": "Advanced settings",
      "reverseOrder": "Reverse order",
      "showDate": "Show publication dates"
    }
  },
  "LinkListItem": {
    "Anchor": "Anchor",
    "ChangeFile": "Change file",
    "File": "File",
    "OpeningRule": "Opening rule",
    "Target": {
      "_blank": "New tab",
      "_self": "Same tab",
      "auto": "Auto",
      "m24ref": "New common tab"
    },
    "Url": "URL"
  },
  "Links": {
    "LinkButtons": {
      "document": "Link to document",
      "event": "Link to event",
      "link": "Link (internal/external)",
      "page": "Link to page"
    },
    "LinkExternal": "Link external",
    "LinkInternal": "Link internal",
    "LinkListBelowBodytext": "Linklist below bodytext",
    "ListChildren": "List all child pages of this page",
    "Options": {
      "button": "Buttons",
      "list": "Text links",
      "arrow_list": "Arrow links",
      "module": "Whole module clickable"
    },
    "SelectLinkStyle": "Show links as",
    "TitleOverLinkList": "Title over link list"
  },
  "ListCardsForPage": {
    "Title": "Cards that point to this page"
  },
  "LocationSelector": {
    "InputLabel": "Location"
  },
  "M24Content": {
    "CaptionHint": "Write your own caption here if the global one doesn't fit the context",
    "EditGlobalMediaData": "Edit global media data in the media gallery",
    "MissingAltTextWarning": "Alternative description is missing",
    "ForcePortraitMode": "Show video in portrait mode",
    "HideZoomButton": "Hide zoom button"
  },
  "M24PageFinder": {
    "M24PageFinderHeader": {
      "ShowDraft": "Show draft"
    }
  },
  "MainMenu": {
    "analytics": "Analytics",
    "cards": "Cards",
    "content": "Content / Page tree",
    "dashboard": "Dashboard",
    "employees": "Employees",
    "events": "Events",
    "forms": "Forms",
    "media": "Media gallery",
    "settings": {
      "cardCategories": "Card categories",
      "categories": "Categories",
      "keywords": "Keywords",
      "language": {
        "create": "Add new language",
        "title": "Language settings"
      },
      "locations": "Locations",
      "pageTemplates": "Templates",
      "sharing": "Access and sharing",
      "site": "Settings",
      "users": "Users",
      "webpage": "General",
      "owner": "Owner structure"
    },
    "styles": "Colors and stylesheet",
    "stylesDescription": "You can click on the webpage icon in the header or the link below to see how the styles look in the portal."
  },
  "Manual": {
    "article__card": "https://manual.museum24.no/faktakort",
    "article__openinghours": "https://manual.museum24.no/apningstider",
    "article__person": "https://manual.museum24.no/person",
    "article__sharing": "https://manual.museum24.no/deleknapper",
    "calendar": "https://manual.museum24.no/kalender",
    "calendar__navigator": "https://manual.museum24.no/kalender",
    "digitaltMuseum": "https://manual.museum24.no/overgang-fra-gammel-til-ny",
    "kulturpunkt": "https://manual.museum24.no/overgang-fra-gammel-til-ny",
    "search": "https://manual.museum24.no/sokeresultat"
  },
  "MapV2Block": {
    "AddLocation": "Add location",
    "InfoBoxHtml": "<p><em>This is a new and simplified map module. Displaying of KulturPunkt and DigitaltMuseum on maps is now done easily in their own dedicated modules.<em></p><p><em><a href=\"https://manual.museum24.no/kart\">More on these modules here</a></em></p>",
    "InfoBoxZoom": "The map view zooms in automatically based on the points, so that the map will always show all the points on the map. If there are several points placed close to each other, these will be shown grouped (clustered), which are shown as single points when the user zooms in on the map.",
    "MapDesign": {
      "black_white": "Black and white",
      "label": "Map style",
      "normal": "Normal"
    },
    "MapType": {
      "ROADMAP": "Roadmap",
      "SATELLITE": "Satellite",
      "label": "Type"
    },
    "addSiteLocationHelpText": "Registered locations from settings that will be displayed on the map.",
    "addSiteLocationLabel": "Select registered locations",
    "enableMapTypeHelperText": "Let user choose maptype",
    "enableMapTypeLabel": "Activate map type selector",
    "enableStreetViewHelperText": "Let the user activate Google Street View in the map",
    "enableStreetViewLabel": "Activate Street View",
    "enableWayfinderLabel": "Activate way finder",
    "enableWayfinderLabelHelperText": "Show a button to let the user start the wayfinder to the destination"
  },
  "MapV2MarkerFormField": {
    "missingTitle": "Location without name"
  },
  "MediaBlock": {
    "AudioVideoContentMessage": "For VIDEO and AUDIO, there are now dedicated modules. Feel free to move this content to one of these modules for better display and more relevant editing options.",
    "CompareTwoImages": "The next two images are compared",
    "ColumnSizeLabel": "Column size (on larger screens)",
    "ColumnSizeHelperText": "Remember that you can also choose the module width at the top.",
    "EnableZoomButton": "Make images clickable (View large version of the image)",
    "ExternalContentMessage": "For external VIDEO and AUDIO, there are now dedicated modules. Feel free to move this content to one of these modules for better display and more relevant editing options.",
    "DisableCaptions": "Hide captions on all images (shown in full view)",
    "Layout": {
      "Auto": "Auto fill (image fills the frame)",
      "Frame": "Show full image (frame filled with module background color/skin)"
    },
    "MissingImageToCompare": "Missing image to compare. Please select one below.",
    "ShowCaptions": "Show captions",
    "ShowCaptionsInFullScreen": "Show captions in full view",
    "ShowCaptionsUnderThumbnails": "Show captions under thumbnails",
    "SizeLabel": {
      "default": "Small",
      "large": "Large",
      "medium": "Medium"
    }
  },
  "MediaEditor": {
    "AltText": "Alternative text",
    "Caption": "Description",
    "CreditName": "Credit name",
    "CreditType": "Credit type",
    "DAMS": "DAMS",
    "DAMSInfo": "This media item is linked to a DAMS object. Here is some information from the DAMS system about this object. ",
    "DAMSProducers": "Producer/Photographer",
    "DAMSSubjects": "Subjects",
    "DAMSPlaces": "Places",
    "DAMSLicenses": "License",
    "DownloadFile": "Download file",
    "HideEditLocales": "Hide text fields for other languages",
    "ImageCaption": "Caption",
    "InUseLinksLabel": "This media resource is in use in the following locations:",
    "LicenseAndCredits": "License and credits",
    "LicenseType": "License type",
    "OpenInNewTab": "Open file in new tab",
    "SaveSuccess": "Media saved",
    "SelectLicense": "Select license",
    "ShowEditLocales": "Show text fields for other languages than mainlanguage",
    "TagsInfo": "Add tags for easier navigation and searching of media items",
    "TagsLabel": "Select or add a new tag...",
    "TextFieldsTitle": "Title, description and alternative text for mainlanguage",
    "Title": "",
    "pickPoster": "Pick poster/cover",
    "removePoster": "Remove poster/cover"
  },
  "MediaList": {
    "NoItems": "No items"
  },
  "MediaView": {
    "AltTextMissingOnMedia": "{{count}} media items are missing alternative text",
    "ConfirmBatchDelete": "Are you sure you want to delete all selected items?",
    "ConfirmBatchRemove": "Are you sure you want to remove all selected items?",
    "ConfirmDelete": "Are you sure you want to delete the item?",
    "ConfirmRemove": "Are you sure you want to remove the item?",
    "Created_at": "Uploaded",
    "Created_by": "Uploaded by",
    "CreditTypes": {
      "artist": "Artist",
      "author": "Author",
      "owner": "Owner",
      "photographer": "Photographer",
      "voice": "Voice",
      "illustrator": "Illustrator",
      "movie": "Film"
    },
    "Remove_selected": "Remove selected",
    "Delete_selected": "Delete selected",
    "EditSelectedMedia": "Edit selected media items",
    "EditState": {
      "group_remove": "Remove batch",
      "group_delete": "Delete batch",
      "group_update": "Update batch",
      "single": "Pick one"
    },
    "Filename": "File name",
    "Filetype": "File type",
    "FilterMissingAlt": "Only media missing alt. text",
    "ShowDamsObjects": "Show DAMS objects",
    "InUse": "In use in {{pages}} pages, {{cards}} cards, {{persons}} persons and {{others}} other places",
    "License": "License",
    "ListView": {
      "Action": "Action",
      "Details": "Details",
      "Media": "Media"
    },
    "MediaId": "M24 media ID",
    "MediaUpdated": "{{nr}} media items were updated",
    "MediaUpload": {
      "Header": "Upload media files",
      "Upload": "Upload",
      "HelpText": "Click to select media files, or drag files here",
      "UploadsFailed": "{{failed}} of {{total}} were not uploaded",
      "FilesUploaded": "{{files}} files were uploaded",
      "OneUploaded": "The file was uploaded",
      "ConfirmLeaveEditStage": "Did you finish editing the uploaded files?",
      "InvalidFilesRemoved": "{{count}} invalid or duplicate files were removed from selection",
      "UploadFiles": "Upload files",
      "AddMetadata": "Add metadata",
      "AddToGallery": "Add to gallery"
    },
    "MissingAlt": "Alternative text missing",
    "NotInUse": "Not in use anywhere",
    "NrSelected": "{{nr}} selected",
    "Tags": "Tags",
    "Title": "Media",
    "Update_selected": "Update selected",
    "Updated_at": "Updated",
    "UpdatesFailed": "{{failed}} of {{total}} items were not updated",
    "UploadMedia": "Upload media"
  },
  "MediaViewTypeSelector": {
    "MediaViewTypeVariant": {
      "compareTwoImages": "Compare",
      "grid": "Image gallery",
      "grid__packery": "Image gallery (auto)",
      "list": "Normal / Columns",
      "slideshow": "Slideshow"
    }
  },
  "Migration": {
    "Cards": {
      "SectionHelpText": "<p>Cards are now created and edited ONLY under \"Cards\", in the same way as \"Employees\". The category system from the old solution is still linked to cards, while the new integrated category system is used for \"Page listing\" and \"Events\"</p><p><a href=\"#todo\">More about these changes here.</a></p>"
    },
    "Persons": {
      "CardBlock": "<p>Persons (employees) are now located/created as Employees in Museum24 2.0, and can be listed with Eployees-modules in the new List-section type</p>",
      "PersonBlock": "<p>Persons (employees) are now located/created as Employees in Museum24 2.0 </p>"
    },
    "article__card": "<p>Fact-cards are no longer supported in Museum24 2.0. Use textmodule or event-descriptions instead</p>",
    "article__openinghours": "<p><strong>Opening hours modules can be replaced with a text module shown as a box.</strong></p>",
    "article__person": "<p><strong>Person modules shown directly on a page or via card modules are replaced with employees and employee modules, if persons represent employees</strong></p>",
    "article__sharing": "<p>Currently no alternative solution available.</p>",
    "calendar": "<p>This module is replaced by new modules located in the new list-section</p>",
    "calendar__navigator": "<p>This module is replaced by new modules located in the new list-section</p>",
    "digitaltMuseum": "<p>This module is replaced by new modules located in the new list-section</p>",
    "intro": "This module is deprecated in Museum24 2.0",
    "kulturpunkt": "<p>This module is replaced by new modules located in the new list-section</p>",
    "preview": "No preview of this module in Museum24 2.0",
    "readMore": "Read more at: ",
    "search": "<p><strong>The search will be replaced by a new standard solution</strong></p>"
  },
  "PageBlockArticleTitleBlockTextAlignSetting": {
    "Tooltip": "Text alignment",
    "options": {
      "auto": "Auto",
      "center": "Center",
      "left": "Left"
    }
  },
  "PageBlockAttachmentViewSetting": {
    "ViewTypeVariant": {
      "grid": "Grid",
      "list": "List"
    },
    "ViewTypeWidth": {
      "none": "Normal",
      "normal": "Normal",
      "wide": "Wide"
    }
  },
  "PageBlockBannerLayoutSetting": {
    "Tooltip": "Layout",
    "options": {
      "box": "Textbox",
      "default": "Variable height",
      "img": "Text on image",
      "img-bottom": "Image under",
      "img-left": "Image left",
      "img-right": "Image right",
      "img-top": "Image over",
      "img-top no-margin": "Image over, no margin",
      "special": "Special",
      "textlines": "Textlines"
    }
  },
  "PageBlockBannerSizeSetting": {
    "Tooltip": "Size",
    "options": {
      "l": "l",
      "l-m": "l-m",
      "m": "m",
      "m-s": "m-s",
      "s": "s",
      "s-m": "s-m",
      "xl": "xl"
    }
  },
  "PageBlockCollapsibleStateSetting": {
    "Tooltip": "Open/closed",
    "options": {
      "collapsed": "Collapsed",
      "expanded": "Expanded",
      "semi": "Semi"
    }
  },
  "PageBlockLayoutSetting": {
    "Tooltip": "Layout",
    "options": {
      "auto": "Auto",
      "full": "Full",
      "fullWidth": "Full width",
      "img-left": "Image left",
      "img-right": "Image right",
      "normal": "Normal",
      "wide": "Wide"
    }
  },
  "PageBlockLinkListViewSetting": {
    "Tooltip": "View type",
    "options": {
      "list": "Simple list",
      "teasers": "Teaser list"
    }
  },
  "PageBlockModuleLayoutSetting": {
    "Tooltip": "Module layout",
    "options": {
      "auto": "Auto",
      "img-landscape": "Landscape",
      "img-portrait": "Portrait",
      "left": "Left",
      "list": "List",
      "right": "Right",
      "img": "Background image"
    }
  },
  "PageBlockModuleTypeSetting": {
    "Tooltip": "Module type",
    "options": {
      "bodytext": "Text",
      "inline": "Text",
      "module": "Text box with background"
    }
  },
  "PageBlockPageListLayoutSetting": {
    "Tooltip": "Layout",
    "options": {
      "img": "Text on image",
      "img-top": "Image over",
      "img-top no-margin": "Image over, without margin",
      "list": "List",
      "textlines": "Textlines"
    }
  },
  "PageBlockPositionSetting": {
    "Tooltip": "Position",
    "options": {
      "full": "Full",
      "left": "Left",
      "normal": "Standard",
      "right": "Right",
      "wide": "Wide"
    }
  },
  "PageBlockTextPositionSetting": {
    "Tooltip": "Text alignment",
    "options": {
      "left": "Left",
      "normal": "Center",
      "right": "Right",
      "wide": "Wide"
    }
  },
  "PageBlockTextSizeSetting": {
    "Tooltip": "Text size",
    "options": {
      "h-large": "Large",
      "h-medium": "Medium",
      "h-normal": "Normal",
      "h-xl": "XL"
    }
  },
  "PageEditor": {
    "mergeWithNextSectionConfirm": "The modules in the section below move to the bottom of this section, and the section below is removed. This section keeps its title and settings.",
    "DeleteDraftConfirm": "Are you sure you want to delete the draft?",
    "missingEventDateWarning": "Time missing",
    "missingMainHeadingWarning": "The regular page heading is not shown on this page. In the top banner, choose to use its title as the page’s main heading (H1).",
    "newTemplateConfirmDialog": {
      "cancel": "No, continue editing this page",
      "navigateToTemplate": "Yes, see template",
      "prompt": "New template created at Settings > Templates. Do you want to go to the template now?"
    }
  },
  "PageFolderAutocomplete": {
    "NoFolder": "No folder"
  },
  "PageListAutoBlock": {
    "Adjustments": "Other settings",
    "Categories": {
      "MainLabel": "Main category",
      "SubLabel": "Sub-categories"
    },
    "ChoosePage": "Choose page",
    "ChoosePageCurrentPage": "Choose this page",
    "Highlight": "Highlight all",
    "MaxSearchResultsSelector": {
      "Label": "Max number",
      "options": {
        "undefined": "Auto"
      }
    },
    "Textlines": "Textlines",
    "OrderBySelector": {
      "Label": "Sorting",
      "options": {
        "published_at": "Publication date",
        "title": "Alphabetical",
        "undefined": "Auto"
      }
    },
    "OrderSelector": {
      "Label": "Sort order",
      "options": {
        "asc": "Ascending",
        "desc": "Descending",
        "undefined": "Auto"
      }
    },
    "PageTreeButtonLabel": "Choose from page tree",
    "RemoveLeftPadding": "Remove padding to the left in banners",
    "SearchLevel": {
      "children": "All pages under the selected page",
      "siblings": "All pages at the same level"
    },
    "SearchPath": {
      "Label": "Selected page",
      "NoSelection": "Not selected"
    },
    "SelectCategoryButtonLabel": "Select category",
    "SitesLabel": "Museums",
    "ThreeCols": "Three column grid"
  },
  "PageListManualBlock": {
    "DisplayInputs": {
      "Label": "Show",
      "displayCategory": "Page category",
      "displayDescription": "Page description",
      "displayInsertTitle": "Insert title",
      "displayLocation": "Place",
      "displayMuseum": "Museum (site)",
      "displayPosition": "Position",
      "displayPublishedDate": "Published date"
    },
    "FilteringOptions": "Enduser filtering options",
    "PageListManualBlockItemContent": {
      "DescriptionHelperText": "Add short intro text if desired",
      "Highlight": "Highlight this link",
      "ImageTopPosition": "Adjust image to top",
      "TitleHelperText": "Write your own heading here, if the standard heading does not fit"
    },
    "PagesLabel": "Pages",
    "NoPagesSelected": "No pages are added to this block yet",
    "SelectPages": "Pick pages"
  },
  "EventListViewTypeSelector": {
    "grid": "Grid",
    "list": "List"
  },
  "EventListLayouts": {
    "img-top": "Image on top",
    "img-top no-margin": "Image on top, no margins/shadows"
  },
  "PageListViewTypeSelector": {
    "grid": "Grid",
    "list": "List (cards)",
    "simple": "Links (titles)"
  },
  "PageMetadata": {
    "EventNotAllowed": {
      "children": "A page with subpages can't be an event.",
      "frontpage": "The front page can't be an event."
    },
    "MainCategoryLabel": "Select main category",
    "SubCategoriesLabel": "Select sub-categories",
    "description": "Page description",
    "mainImageDescription": "The main image is the image that is automatically linked to the page when using maps and link lists in Museum24. Blue. Facebook also uses this image.",
    "mainImageMissingInfotext": "If no main image is set, a random image will be picked from the page if multiple images are added.",
    "metaTitle": "SEO: custom page title",
    "metadescription": "SEO: Description (meta tag)",
    "pageMainImage": "Main image of the page:",
    "selectImageHeading": "Select image from:",
    "syncPageDescription": "Set page description to the same as preamble"
  },
  "PageSettings": {
    "CancelEditPath": "Revert back to: \"{{old}}\"",
    "Category": "Category",
    "CategoryNew": "Category (new)",
    "CategoryOld": "Category (old)",
    "Close": "Close page settings",
    "CloseTemplateSettings": "Close template settings",
    "ConfirmApplyTemplate": "Applying a template will overwrite the current page content. Are you sure you want to continue?",
    "EnableEditPath": "Edit path",
    "FormLabels": {
      "IsLongread": "Use simple headers for Longread article",
      "Slug": "Slug",
      "Title": "Page Title",
      "accessCode": "Access code",
      "pageAlreadyHasAccessCode": "This page already has an access code. If you set a new code, the old code will no longer work.",
      "isProtected": "User must enter a code to open the page",
      "protectedButton": "Protected page: Text on login button",
      "protectedError": "Protected page: Error message (wrong code)",
      "protectedIntro": "Protected page: Short intro",
      "protectedLabel": "Protected page: Text over code input field",
      "protectedTitle": "Protected page: Title"
    },
    "LockedByParentInfo": "This page is locked because a parent page is locked. You can add an additional access code for this page below.",
    "Locations": "Locations",
    "LongreadLogoLink": "Logo link",
    "LongreadLogoText": "Logo (text)",
    "PublishDateTip": "TIP: You can set a future publish date to automatically publish the page at a later time",
    "PublishDateTipLearnMore": "Learn more about scheduled publishing here.",
    "PublishDateTipDescription": "The publish date controls when the page is considered published. If the page is published and this date is in the future, the page will not be visible to the public until that date arrives. This makes it possible to set up scheduled publishing, where you can prepare a page and set it to be published automatically at a later time.",
    "RevisionsTable": {
      "CreatedBy": "Saved by: Name (User ID)",
      "CreatedByName": "Name",
      "Current": "current",
      "EditedVersion": "Version {{number}} \"{{title}}\" ({{status}})",
      "InfoText": "These are the 10 previous saves of the version of the page you are working on now.",
      "InfoTextWithCurrent": "These are the 10 latest saves of the version of the page you are working on now. The top one is current.",
      "RevisionID": "Revision ID",
      "SavedTimestamp": "Saved at",
      "Title": "Title",
      "Version": "Version",
      "VersionID": "Version ID"
    },
    "Sections": {
      "formData": "Form data",
      "general": "General settings",
      "languageConnections": "Language connections",
      "newsletters": "Newsletters",
      "revisions": "Revisions",
      "security": "Security",
      "versions": "Versions"
    },
    "SelectTemplateLabel": "Template",
    "SelectTemplateButton": "Select template",
    "SelectTemplateDisabled": "You must first save the page as a new version/draft before you can use a template",
    "SelectTemplateDescription": "Here you can set content from a \"template\". A template is a page with a complete setup with sections and modules, but without any content (text, media, etc).",
    "VersionsTable": {
      "Choosen": "Choosen (currently editing)",
      "Count_one": "{{count}} version",
      "Count_other": "{{count}} versions",
      "Created": "Created",
      "CreatedBy": "Created by: Name (User ID)",
      "Current": "Current",
      "InfoText": "This is an overview of all versions created of this page. In Museum24 2.0 a new version is created every time a new draft is saved of a page that is already published. Editorial work can only be done on the current version and drafts newer than it. Versions older than the current version are shown as \"Superseded\".",
      "No": "No",
      "OptVersionTitle": "Optional version title",
      "Superseded": "Superseded",
      "VersionID": "Version ID",
      "VersionStatus": "Version status",
      "Yes": "Yes"
    },
    "LanguageConnections": {
      "Intro": "Here you can add or remove connections between pages on the website's main language and corresponding pages on other languages. This will enable the language selector in the end portal to provide direct links between corresponding pages on different languages. The connections will be two-way. If no connections are specified, the language selector in the end portal will always link to the other language's front page.",
      "IntroNotMainLanguage": "Connections between pages on different languages can only be managed through pages that are on the website's main language.",
      "ConnectPage": "Connect to page",
      "RemoveConnection": "Remove connection",
      "CurrentPageLanguage": "This page's language",
      "MainLanguage": "Main language",
      "NoConnection": "No connection",
      "OtherLanguages": "Other languages",
      "PageConnections": "This page is connected with:",
      "ConnectedTo": "Connected to: {{languages}}"
    },
    "Restore": {
      "Button": "Restore",
      "ConfirmText": "Do you want to restore the content from {{source}}? A new version (draft) is created with this content, and it has to be published to become visible. Page level fields, such as path, page title and main image, keep their current values.",
      "DraftExists": "The page already has a draft. Publish or delete the draft before restoring.",
      "Failed": "Could not restore the content.",
      "RenameFailed": "A new version was created, but its version title could not be set.",
      "RevisionLabel": "revision {{id}} ({{time}})",
      "Success": "The content has been restored in a new version.",
      "UnsavedChanges": "You have unsaved changes. Save or discard them before restoring.",
      "VersionLabel": "version {{number}}",
      "VersionTitle": "Restored from {{source}}"
    },
    "Protected": "Protected",
    "ProtectedByParent": "Protected by parent page"
  },
  "PageSizeSelector": {
    "NumberOfElementsToShow": "Number of elements to show"
  },
  "PageTree": {
    "NoImportedPages": "No imported pages waiting for placement",
    "NoPagesFound": "No pages found"
  },
  "PageTreeActionMenu": {
    "DeleteWithChildrenQuestion": "The pages under this page are deleted as well. Are you sure?",
    "MenuItems": {
      "Archive": "Archive",
      "DeletePage": "Delete",
      "MoveToFolder": "Move to folder...",
      "Preview": "Preview",
      "Publish": "Publish",
      "PublishWithChildren": "Publish with subpages",
      "ShowInPortal": "Show in portal",
      "Unpublish": "Avpubliser"
    }
  },
  "PageTreeBulkOperations": {
    "archive": "Archive",
    "delete": "Delete",
    "deleteImportedChildrenNote": "Pages under the selected pages are deleted as well.",
    "deleteImportedQuestion": "The selected pages are deleted. Are you sure?",
    "deleteImportedTitle": "Deleting imported pages",
    "deleteImportedHint": "Do not close the window until the deletion has finished.",
    "deleteImportedProgress": "Deleting {{done}} of {{total}} pages …",
    "moveEvents": "Move events",
    "movePages": "Move pages",
    "publish": "Publish",
    "publishImportedChildrenNote": "Pages under the selected pages are published as well.",
    "publishImportedQuestion": "The selected pages are published and placed at the root of the page tree. Continue?",
    "unpublish": "Unpublish"
  },
  "PageTreeCheckbox": {
    "Tooltips": {
      "HasChildren": "Press SHIFT + CLICK to select/deselect all sub-pages",
      "NotSelectedAndPartiallySelectedChildren": "This page is NOT selected, but some of it's children are. $t(PageTreeCheckbox.Tooltips.HasChildren)",
      "SelectedAndPartiallySelectedChildren": "This page and some of it's sub-pages are selected. $t(PageTreeCheckbox.Tooltips.HasChildren)"
    }
  },
  "PageTreeContent": {
    "HasDraftVersion": "Has draft version",
    "addSubPageButtonLabel": "New sub page",
    "edit": "Edit",
    "editEventButtonLabel": "Edit event",
    "editPageButtonLabel": "Edit page",
    "missingDate": "Date is missing",
    "movePagesHereButtonLabel": "Move selected pages under this"
  },
  "PageTreeFilter": {
    "ClearAllFiltersTooltip": "Clear all filters"
  },
  "PageTreeToolbar": {
    "MovePageToFolderDialog": {
      "Cancel": "Cancel",
      "ConfirmMove": "Move",
      "Title": "Move to folder"
    },
    "filterCategoriesButtonLabel": "Filter categories",
    "locations": "Locations",
    "noLocationsFound": "No locations found",
    "subCategoryLabel": "Category",
    "toggleLastEditedButtonLabel": "Last edited",
    "toggleSelectionModeButtonLabel": "Select multiple"
  },
  "PreviewWrapper": {
    "PreviewMode": {
      "developer": "Developer",
      "normal": "Normal"
    }
  },
  "ProgramBlock": {
    "AddProgramTime": "Add program time",
    "ProgramTimeItem": {
      "Description": "Description",
      "From": "From",
      "ProgramTime": "Program time",
      "RemoveProgramTimeItem": "Remove program time",
      "Title": "Title",
      "To": "To"
    }
  },
  "QuoteBlock": {
    "byline": "Byline",
    "quote": "Quote"
  },
  "RadioInput": {
    "NoValue": "None"
  },
  "SearchSelector": {
    "noMatch": "No match"
  },
  "SectionDirectionSelector": {
    "Tooltip": "Direction",
    "options": {
      "carousel": "Carousel",
      "introbanners": "Beta: IntroBanners",
      "ltr": "To right",
      "rtl": "To Left",
      "snappy": "Beta: Snappy Banners"
    }
  },
  "SectionWidthSelector": {
    "Tooltip": "Width",
    "options": {
      "article__grid": "Narrow",
      "full__grid": "Full (100%)",
      "section__grid": "Page width",
      "wide__grid": "Wide"
    }
  },
  "SelectButton": {
    "Deselect": "Deselect",
    "Select": "Select"
  },
  "SelectInput": {
    "NoSelection": "No selection"
  },
  "SelectedDMMediaItem": {
    "License": "License",
    "Owner": "Owner"
  },
  "Settings": {
    "LanguageSettings": {
      "404": {
        "404pageMissing": "404-page is missing",
        "addPageButton": "Pick page",
        "pagenotfoundInfoMessage": "Only used if 404 page is missing",
        "pagenotfoundText": "\"Page not found\" text",
        "pagenotfoundTitle": "\"Page not found\" title",
        "title": "404 - Page not found"
      },
      "keypages": {
        "dmFilterPage": "DigitaltMuseum filter page",
        "dmFilterPageInfo": "This page should contain a DigitaltMuseum filter module set up to display search results from DigitaltMuseum. The end user returns to this page when searching via clicks on places, keywords, etc. in an integrated DigitaltMuseum full view."
      },
      "LanguageCreationView": {
        "description": "Short description",
        "languagetext": "Language",
        "languagetextPlaceholder": "I.e. \"Norwegian\"",
        "name": "Name of the web site in this language"
      },
      "LanguageFooterSettings": {
        "address": "Address",
        "addressLabel": "Lead text",
        "addressTitle": "Address",
        "addressesTitle": "Extra addresses",
        "copyright": "Copyright",
        "editor": "Editor",
        "editorLabel": "Editor label",
        "email": "E-mail",
        "emailLabel": "E-mail label",
        "infoText": "Addresses  and contact information im footer will be fetched from web site settings, but can be overrid here to handle translations.\nMore address lines can also be added.",
        "info_deprecated": "Info deprecated (footer): remove data from here",
        "link": "Link to contact information",
        "menu": {
          "cssClass": "CSS class",
          "includeNavPath": "Include search field in footer (uses search settings from header)",
          "includeSearchField": "Include navigation path in footer",
          "menuPointTitle": "Title of menu point",
          "subMenu": "Sub menu"
        },
        "menuTitle": "Menu",
        "name": "Name",
        "openInNewWindow": "Open in new window/tab",
        "orgNumber": "Org-number",
        "orgNumberLabel": "Org-number-label",
        "phone": "Phone number",
        "phoneLabel": "Phone label",
        "postalCode": "Postal code",
        "postalPlace": "Postal place",
        "privacyLink": "Link to privacy policy",
        "privacyLinkLabel": "Text for privacy policy link",
        "privacySettingsLabel": "(KIT CCM) Change Privacy settings label",
        "responsibleEditor": "Resposible editor",
        "responsibleEditorLabel": "Resposible editor label",
        "transparencyActLink": "Link to transparency act",
        "transparencyActLinkLabel": "Text for transparency act link",
        "social": {
          "facebook": "Facebook",
          "flickr": "Flickr",
          "instagram": "Instagram",
          "linkedin": "LinkedIn",
          "pinterest": "Pinterest",
          "textFieldLabel": "Text",
          "textFieldPlaceholder": "Visit us at...",
          "tripadvisor": "TripAdvisor",
          "twitter": "Twitter",
          "vimeo": "Vimeo",
          "youtube": "YouTube",
          "tiktok": "TikTok"
        },
        "socialTitle": "Social sharing",
        "text": "Free text",
        "uuLink": "Link to availability statement",
        "uuLinkLabel": "Text for availability statement"
      },
      "LanguageInfoSettings": {
        "defaultLanguage": "Set as default language",
        "pageInfo": {
          "description": "Short description",
          "name": "Web page name",
          "title": "Web page information",
          "overrideLocale": "Overide language-code",
          "translations": "Translations",
          "KulturPunktLabel": "Kulturpunkt",
          "KulturPunktHitsLabel": "Kulturpunkt hits"
        }
      },
      "LanguageLogoSettings": {
        "logoEcoLighthouse": "Logo Eco Lighthouse",
        "logoEcoLighthouseLink": "Link to Eco Lighthouse",
        "logoConsolidatedFooter": "Logo consolidated footer",
        "logoConsolidatedHeader": "Logo consolidated header",
        "logoFooter": "Logo footer",
        "logoFooterGlobal": "Logo footer (for all languages)",
        "logoHeader": "Logo header",
        "logoHeaderGlobal": "Logo header (for all languages)",
        "logoTitle": "Logo title with support for line breaks",
        "parentUrl": "Link to consolidated museum",
        "svgCode": "SVG code",
        "parentName": "Name of consolidated museum",
        "parentText": "Text above logo"
      },
      "LanguageMenuSettings": {
        "addPageButton": "Pick page",
        "availableLanguages": "Available languages",
        "consolidatedInfo": "Consolidated information",
        "consolidatedLink": "Consolidated URL",
        "consolidatedLine": "Consolidated line",
        "consolidatedLogo": "Consolidated logo (SVG)",
        "consolidatedName": "Consolidated museum name",
        "cssClass": "CSS class",
        "focusMenu": "Focus menu",
        "includeConsolidatedLine": "Show consolidated line",
        "includeConsolidatedLogo": "Show consolidated logo",
        "includeInfoLine": "Show info line",
        "infoLineFrontPageOnly": "Show only on front page",
        "includeLanguageMenu": "Show language menu",
        "includeSearchButton": "Display search button in search field",
        "includeSearchField": "Show search field",
        "infoLine": "Info line",
        "infoLineText": "Info line text",
        "infoLineButtonText": "Info line button/link text",
        "infoLineShowAsLink": "Show as a textlink on all screen sizes",
        "infoLineLink": "Info line link (url)",
        "infoLineSkin": "Info line skin",
        "languageMenu": "Language menu",
        "languageTitleInMenu": "Title of language in menu",
        "languagesInMenu": "Language menu (in your preferred order)",
        "mainMenu": "Main menu",
        "menuPointTitle": "Menu point title",
        "searchButtonText": "Text on search button",
        "searchField": "Search field",
        "searchFieldText": "Text in search field",
        "searchresultPage": "Search results page",
        "subMenu": "Sub menu",
        "url": "Url"
      },
      "SEO": {
        "description": "SEO Description (meta-tag)",
        "keywords": "SEO Keywords (meta-tag)",
        "title": "Search optimalization",
        "enableSitemap": "Enable automatic sitemap.xml for this language"
      },
      "childCount_one": "1 item",
      "childCount_other": "{{count}} items",
      "childCount_zero": "No items"
    },
    "SiteSettings": {
      "SiteCategoriesSettings": {
        "Info": {
          "Clarification": "Categories were previously mainly used to easily retrieve pages/cards automatically. This can noe be solved with modules for automatic (and manual) page listing, so the old categories are now redundant.",
          "Definition": "CATEGORIES are now pre-defined in Museum24. This is to more easily be able to use categories across different sites. Some categories also have sub-categories for better filtering. \"Event\" has also become a distinct page type.",
          "ReadMoreCategories": "Read more about categories",
          "ReadMoreEvents": "Read more about Event as a new page type",
          "ReadMorePageListing": "Read more about page listing"
        }
      },
      "SiteKeywordsSettings": {
        "deleteConfirm": "Are you sure you want to delete?",
        "displayOnlyUnused": "Show only unused keywords",
        "infoText": "Keywords can be created and applied to content to create easier retrieval, as well as options for searching for content with given keywords towards the end user. Here you can manage keywords, remove keywords that should not be used, fix misspellings, duplicates, etc. Listed below are all tags created for this site. While entering a new tag, you will be able to see in the list below whether this already exists.",
        "newCardCategory": "Seach, or add new card category",
        "newKeyword": "Seach, or add new keyword",
        "sorting": "Sorting",
        "tag": "Keywords"
      },
      "SiteLocationsSettings": {
        "changeCoordinates": "Change coordinates",
        "deleteConfirmBody": "Are you sure you want to delete this location?",
        "deleteConfirmTitle": "Delete location",
        "full_address": "Full address",
        "infoText": "Places you create here will be able to be found again and linked to other content that you want to set a location for",
        "missingTitle": "Place name is missing",
        "postal_code": "Post code",
        "postal_town": "Town",
        "street_name": "Street",
        "titleInputLabel": "Name of place/location"
      },
      "SitePageTemplateSettings": {
        "deleteTemplateError": "There was an error when deleting the template",
        "deleteTemplateSuccess": "Template deleted",
        "editTemplateButton": "Edit template",
        "infoText": "Templates allow you to save the setup for an existing page, and quickly create more pages like it.",
        "readMoreLabel": "Read more about templates here"
      },
      "SiteSharingSettings": {
        "Events": {
          "title": "Export of events (JSON)",
          "intro": "The URL below delivers this website's upcoming events (up to one year ahead) as JSON data for import into other services. The data format we offer has been developed specifically for export to Visit services in Norway (operated by SimpleView). If you want to export from multiple websites via the same URL, you must include the IDs of those websites, separated by commas, in the URL via ?site_id=ID1,ID2,etc. If you choose another website language in the language selector at the top right, you will also get a URL for retrieving events in that language."
        },
        "SharingContentType": {
          "content": "Content (pages, cards, events, employees)",
          "label": "Content type",
          "resources": "Media",
          "templates": "Templates"
        },
        "SiteSharingSettingsNewAgreementModal": {
          "selectSite": "Select site",
          "titles": {
            "given": "Give new access to:",
            "granted": "Apply for new access to:"
          }
        },
        "accessToX": "You have access to: ({{x}})",
        "addNewAccess": "New access",
        "addNewApplication": "New application",
        "contentType": "Content type",
        "sharingWithX": "You are sharing with: ({{x}})",
        "unsavedChanges": "You have unsaved changes! Press 'Save' to confirm the changes."
      }
    },
    "WebpageSettings": {
      "General": "General",
      "SiteID": "Site ID",
      "SiteName": "Site name and description",
      "SiteDefaultLanguage": "Default language",
      "SiteUrl": "Site domain/url",
      "WebpageEKulturIntegrationsSettings": {
        "title": "E-kultur integrations",
        "digitaltMuseum": "DigitaltMuseum",
        "dmOwners": "DigitaltMuseum owner idents",
        "dmIncludedInSiteSearch": "Include hits from DigitaltMuseum in site search",
        "dmIntegratedView": "Use integrated view for DigitaltMuseum",
        "kulturPunkt": "KulturPunkt",
        "kulturpunktOwnerID": "KulturPunkt Museum ID",
        "kpComplete": "Show full KulturPunkt when integrated view",
        "kulturpunktIncludedInSiteSearch": "Include hits from KulturPunkt in site search"
      },
      "WebpageIconsSettings": {
        "title": "Icons",
        "addFileButtonLabel": "Add logo file",
        "favicon": "Favicon",
        "faviconCaption": "Small image/icon that is shown in the web browser tab",
        "noImageChosen": "No image",
        "touchicon": "The webpage's touch icon",
        "touchiconCaption": "Icon if someone makes a shortcut on their smartphone",
        "otherIconSettings": "Other icon settings",
        "disableEkulturMapPin": "Do not use Ekulltur map pins",
        "disableKPmapPin": "Do not use KP map-pin",
        "disableDMmapPin": "Do not use MP map-pin"
      },
      "WebpageConsentSettings": {
        "title": "Consent management",
        "gdprScripts": "Scripts from other providers (usersentric, cookiebot etc.)",
        "KitCMP": "Standard Ekultur consent solution (under development!)",
        "KitCMPdescription": "This is configured via Ekultur's administration solution for consent management per site/museum. The solution will be available for use when it is fully developed. However, it is intended as an option for those who do not have other solutions for consent management and do not use external analytics or marketing tools that require consent.",
        "KitCMPisActive": "The solution is activated for this site",
        "KitCMPisInactive": "The solution is not activated for this site",
        "activateKitCMP": "Activate Ekultur consent solution",
        "activateKitCMPbutton": "Show fixed button for changing consent",
        "enableGdprInTestEnvironments": "Activate consent solution in test environment",
        "KitCMPTestScript": "TestScript (to test the consent solution while it is under development)",
        "OtherCMP": "Other consent solution (Usercentric, Cookiebot etc.)",
        "OtherCMPDescription": "If you already have a consent solution you want to use, KulturIT can add scripts for this here, or under language settings (if different scripts for different languages). A Google Consent Certified must be used if you want to link external statistics and marketing tools (such as Google Analytics, Google Tagmanager, Facebook Pixel etc.) to the website.",
        "OtherCMPscript": "Script for other consent management provider",
        "OtherCMPisActive": "Other consent solution is activated for this site"
      },
      "WebpageTrackingSettings": {
        "title": "Tracking",
        "facebook": "Facebook",
        "facebookDomainVerification": "Facebook Domain Verify",
        "facebookDomainVerificationCaption": "Add only your domain vericiation ID",
        "facebookDomainVerificationPlaceholder": "E.g. a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5",
        "facebookPixcelCode": "Facebook/Meta Pixel ID",
        "facebookPixcelCodeCaption": "Add only your pixel code \"ID\"",
        "facebookPixcelCodePlaceholder": "E.g. 123456789012345",
        "onlyKeysWarning": "Only enter the key/ID itself in these fields – never a script or code (e.g. <script>…</script> or <meta …>). Code pasted here will not work and may cause errors on the website.",
        "google": "Google",
        "googleGtagKey": "Google Analytics 4 Key",
        "googleMapsKey": "Map: Google Maps Key",
        "googleMapsKeyPlaceholder": "AIzaSy… (if you have your own key for this site)",
        "googleSiteVerification": "Google Site Verification UID (Webmastertools)",
        "googleSiteVerificationCaption": "Only enter the value from content=\"…\" in the meta tag Google gives you. If this method does not work, there are other ways to verify the site – contact KulturIT.",
        "googleTagmanagerKey": "Google Tagmanager Key",
        "enableStructuredGoogleBreadcrumbs": "Enable Google structured data for breadcrumbs",
        "enableStructuredGoogleEvents": "Enable Google structured data for events",
        "plausible": "Plausible (Standard cookieless tracking)",
        "plausibleDescription": "Standard tracking for webpages in Museum24. No cookies, no personal data. Statistics integrated in Museum24 adminclient.",
        "plausibleEnable": "Enable Plausible tracking",
        "plausibleEnabled": "Plausible is enabled for this site",
        "plausibleNotEnabled": "Plausible is not enabled for this site",
        "plausibleWebsiteId": "Plausible Website ID (if other than sites domain)",
        "plausibleExtraTrackerId": "Plausible extra Tracker ID",
        "plausibleAuth": "Embed AUTH code for Plausible (can be used instead of plausibleEmbedUrl)",
        "plausibleScriptId": "Plausible Script ID (NEW METHOD)",
        "plausibleUniqueDomain": "If no other sites share the same domain, check this box",
        "plausibleEnableLocalhostTracking": "Enable tracking on localhost (for local testing)"
      },
      "WebpageSearchSettings": {
        "title": "Search on multiple sites",
        "description": "What other sites do you want to be able to search against?",
        "availableSites": "Available sites based on agreements",
        "search": "Search"
      },
      "WebpageSystemSettings": {
        "title": "System settings",
        "description": "Scripts (Consent, Newsletter, etc.). Only available to super admins.",
        "gdprScripts": "GDPR scripts",
        "scripts": "Scripts/Styles (Header)",
        "footerScripts": "Scripts (At bottom)",
        "diverse": "Miscellaneous settings",
        "cssClass": "CSS classes (body)",
        "siteIsNotAphysicalLocation": "This site is not a physical location (not displayed at events)",
        "dmChannel": "This site is a DigitaltMuseum channel"
      },
      "WebpageContactInfoSettings": {
        "title": "Contact information (language-independent)",
        "description": "Contact information displayed in the footer. Can be overridden in footer settings per language."
      }
    },
    "titles": {
      "404": "404 page",
      "categories": "Categories",
      "create": "Add new language",
      "eKulturIntegrations": "eKultur-integrations",
      "footer": "Footer",
      "footerMenu": "Footer menu",
      "keypages": "Key pages",
      "keywords": "Keywords",
      "language": "Language",
      "languageInfo": "Information",
      "locations": "Locations",
      "logo": "Logo",
      "menu": "Header / Menu",
      "seo": "SEO / Meta",
      "sharing": "Access and sharing",
      "site": "Site settings",
      "tracking": "Tracking and links",
      "users": "Users",
      "webpage": "Web page settings",
      "webpageIcons": "Web page icons",
      "webpageInfo": "Web page information"
    }
  },
  "SiteSelector": {
    "selectOrChangeActiveSite": "Select or change active site",
    "selectOrChangeActiveSiteLanguage": "Select or change active site language"
  },
  "SiteSharingBlockSettings": {
    "MuseumSharingInfo": "Are you missing museums? Check sharing agreements",
    "SelectAll": "Select all",
    "SelectSites": "Select museums to filter by",
    "UnselectAll": "Unselect all"
  },
  "SiteUsersSettings": {
    "name": "Name",
    "email": "Email",
    "role": "Role"
  },
  "SkinSelector": {
    "SelectSkinTooltip": "Select skins"
  },
  "SortMenu": {
    "Asc": "Ascending",
    "Date": "Last changed",
    "Desc": "Descending",
    "SortBy": "Sort by",
    "SortDirection": "Direction",
    "SortMenuTooltip": "Sort pages",
    "Status": "Status",
    "Title": "Title"
  },
  "TableBlock": {
    "AddRow": "Add row",
    "ColAsHeader": "Use the first column as header",
    "ConfirmParseTable": "Are you sure you want to convert the table? Existing contents will be overwritten.",
    "DisplayState": {
      "collapsed": "Collapsed",
      "expanded": "Expanded"
    },
    "NoBorder": "No border",
    "StripedHorizontal": "Striped horizontal lines",
    "FooterText": "Footer text",
    "HideInputField": "Hide input field to copy and paste external tables",
    "InitialStatePlaceholder": "Display state",
    "InputFieldPlaceholder": "Copy and paste table from web page, spreadsheet etc.",
    "NrOfColumns": "Number of columns",
    "ParseWithComma": "Make table with comma as separator",
    "ParseWithTab": "Make table with tab as separator",
    "RowAsHeader": "Use the first row as header",
    "SelectInitialState": "Select how the table is initially displayed",
    "ShowInputField": "Show input field to copy and paste external tables"
  },
  "TextBlock": {
    "SplitCancel": "Cancel",
    "SplitHere": "Split here",
    "SplitMode": "Split module",
    "SplitModeInfo": "Click in the text where the module should be split. The red line shows the spot, and everything in the shaded area moves to a new text module right below. Title, image and links stay here.",
    "SplitModeTooltip": "Split the module in two",
    "SplitNothingAfter": "There is no text after the cursor. Move the cursor to where the module should be split.",
    "HideBodyText": "Hide body text and show it when title is clicked",
    "IconHelpText": "Icon  is only visible in textbox-view",
    "TextEditorType": "Change text editor",
    "TitleOverLinkList": "Title over link list",
    "localCaption": "Local caption",
    "localCaptionDescription": "Overrides global caption"
  },
  "ToggleExpandAllButton": {
    "ContractAll": "Contract all",
    "ExpandAll": "Expand all"
  },
  "ToggleSelectAllCheckbox": {
    "CountItemsSelected_one": "{{count}} page selected",
    "CountItemsSelected_other": "{{count}} pages selected",
    "DeselectAll": "Deselect all",
    "SelectAll": "Select all"
  },
  "UserAvatarMenu": {
    "siteRole": "Your site role is ",
    "logOut": "Log out",
    "ownerSettings": "Owner settings ({{owner}})",
    "settings": "Site settings ({{site}})"
  },
  "ViewTypeSelector": {
    "SelectViewTypeVariant": "Select view type",
    "SelectViewTypeWidth": "Select width",
    "ViewTypeWidth": {
      "full": "Site Width",
      "narrow": "Middle column",
      "none": "Auto",
      "wide": "Wide"
    }
  },
  "WidgetBlock": {
    "height": "Iframe height",
    "html": "HTML code (SVG, simple HTML tags, third party JS widgets)",
    "isWidget": "This is a script/widget",
    "src": "Iframe SRC",
    "width": "Iframe width",
    "iframeSettings": "Settings for iframe",
    "additionalSettings": "Additional settings (alternative content)",
    "externalUrl": "External URL (display at 3rd party service)",
    "widgetDescription": "Describe the service in a few words",
    "convert": "Convert widget",
    "convertInfo": "If the Widget is used for third-party audio/video services (Soundcloud, Spotify, YouTube, etc.), you can convert it here to a new audio/video module. This will organize the content on the website more precisely. Data in the module will automatically be transferred to the new module.",
    "convertConfirm": "Are you sure you want to convert this widget?",
    "convertToAudio": "Convert to AUDIO module",
    "convertToVideo": "Convert to VIDEO module",
    "securityInfo": "<strong>IMPORTANT:</strong> ONLY enter code from trusted and verified sources and third-party providers here. If you are unsure about the code, please contact KulturIT for assessment and guidance. KulturIT will also regularly check the content of the Widget module to assess security.<br/><br/>NOTE! Museum24 has dedicated modules for Audio and Video, so please use these for audio and video. The Widget module can also be easily converted to an audio or video module. See the very bottom of the module."
  },
  "AudioBlock": {
    "title": "Title",
    "filename": "Filename",
    "source": "Audio source",
    "sourceEkultur": "Audio from Ekultur (Museum24, DigitaltMuseum)",
    "sourceExternal": "External audio provider (Soundcloud, Spotify, or similar)",
    "provider": "Audio provider",
    "other": "Other",
    "providerHelpText": "Select a provider for the audio. If you can't find the provider here, choose Other and notify KulturIT about this.",
    "m24Sound": "Audio from Museum24 gallery",
    "pickM24Sound": "Pick audio from Museum24 gallery",
    "pickDMSound": "Pick audio object from DigitaltMuseum",
    "localTitle": "Local title (if different from the object title)",
    "localCaption": "Local description (if different from the object description)",
    "disableCredits": "Hide credits",
    "securityInfo": "<strong>IMPORTANT:</strong> ONLY enter code from trusted and verified sources and third-party providers here. Select a provider from the dropdown list. If you are unsure about the code, please contact KulturIT for assessment and guidance."
  },
  "VideoBlock": {
    "source": "Video source",
    "sourceEkultur": "Video from Ekultur (Museum24, DigitaltMuseum)",
    "sourceExternal": "External video provider (YouTube, Vimeo, or similar)",
    "provider": "Video provider",
    "other": "Other",
    "providerHelpText": "Select a provider for the video. If you can't find the provider here, choose Other and notify KulturIT about this.",
    "m24Video": "Video from Museum24 gallery",
    "pickM24Video": "Pick video from Museum24 gallery",
    "pickDMVideo": "Pick video object from DigitaltMuseum",
    "localTitle": "Local title (if different from the object title)",
    "localCaption": "Local description (if different from the object description)",
    "disableCredits": "Hide credits"
  },
  "ReferencesBlock": {
    "addReference": "Add reference/source",
    "referenceLabel": "Reference/source",
    "referencePlaceholder": "Enter reference here",
    "date": "Year / Date",
    "media": "Media (Journal, newspaper, possibly thesis)",
    "issue": "Edition (no./year)",
    "pageNumber": "Page number",
    "publisher": "Publisher (possibly school)",
    "place": "Place",
    "author": "Author / Editors / ID of document etc.",
    "title": "Title of work",
    "sitename": "Site name",
    "url": "URL (if available online)",
    "referenceType": "Type of reference",
    "referenceNumber": "Reference number",
    "reportNumber": "Report number",
    "referenceTypeOptions": {
      "article": "Article",
      "book": "Book",
      "chapter": "Chapter",
      "document": "Document",
      "film": "Film",
      "interview": "Interview",
      "map": "Map",
      "newspaper": "Newspaper",
      "report": "Report",
      "website": "Website",
      "other": "Other"
    }
  },
  "common": {
    "setAsPageMainImage": "Use as the main image for the page"
  }
}
